
import React, {useState, useEffect} from 'react';
import { FaEyeSlash, FaEye, FaTable } from 'react-icons/fa';
import {TextCompareItem} from '../TextCompareItem/TextCompareItem'

import {runQuery} from '../utils'
import {basicInfoQuery} from './queries'

// Type alias for URL strings
type SCTAExpressionUrlId = string;

// Define props using an interface
interface MyComponentProps {
  // Define your prop types here
  expressionid: SCTAExpressionUrlId,
  isMainText?: boolean,
  relationLabel?: string,
  referringResource?: string,
  handleAddCtRelatedExpressions?: (fullEid: string) => void,
  author?: string,
  authorTitle?: string,
  info?: any,
  handleChangeBase?: (rawText: string) => void,
  targetRange?: string,
  isRelatedToRange?: string,
  surfaceWidth?: number,
  longTitle?: string,
  handleShowCollationOverlay?: any
  baseText?: string,
  show?: boolean,
  showImages?: boolean
  handleChangeInfo?: any
  handleUpdateCompareExpressionIds?: any
}



export const TextCompare: React.FC<MyComponentProps> = (props) => {
  
  const [info, setInfo] = useState<any>({resourceid: props.expressionid});
  const [show, setShow] = useState<boolean>(false);
  const [showImages] = useState<boolean>(false);
  // const [baseText, setBaseText] = useState<string>("");
  const [showTranslations, setShowTranslations] = useState<boolean>(false);

  useEffect(() => {
    getTextInfo()
  }, [props.expressionid]);

  const getTextInfo = () => {
    const query = basicInfoQuery(props.expressionid)

    const info = runQuery(query)
    info.then((d: any) => {
          const bindings = d.data.results.bindings[0]
          const manifestations = d.data.results.bindings.map((b: any) => {
            return {
              manifestation: b.manifestation.value,
              manifestationTitle: b.manifestationTitle.value,
              manifestationLanguage: b.manifestationLanguage?.value,
              transcription: b.manifestationCTranscription ? b.manifestationCTranscription.value : "",
              transcriptionDoc: b.manifestationCTranscriptionDoc?.value
    
            }
          })
          if (bindings){
            const info = { 
              resourceid: props.expressionid,
              title: bindings.title?.value,
              structureType: bindings.structureType?.value,
              inbox: bindings.inbox?.value,
              next: bindings?.next?.value,
              previous: bindings?.previous?.value,
              cdoc: bindings?.cdoc?.value,
              cxml: bindings?.cxml?.value,
              topLevel: bindings.topLevelExpression?.value,
              cmanifestation: bindings?.cmanifestation?.value,
              ctranscription: bindings?.ctranscription?.value,
              manifestations: manifestations
            }
            setInfo(info);
          }
        });
      }
      const displayComparisons = () => {
        // NOTE: this conditional here to stop attempt to display text manifestation texts at the collection level
        // collection level is usually just too big to be useful. 
        if (props.isMainText && props.info.structureType === "http://scta.info/resource/structureCollection"){
          return <p>Text too big to display; move down the text hierarchy to focus on a smaller section</p>
        }
        else if (info.manifestations){
          const texts = info.manifestations.map((m: any) => {
            if (m.manifestationLanguage === "la"){
            return (
              <TextCompareItem
              key={m.transcription}
              base={props.baseText}
              compareTranscription={m.transcription}
              compareTranscriptionDoc={m.transcriptionDoc}
              manifestationTitle={m.manifestationTitle}
              manifestation={m.manifestation}
              handleChangeBase={props.handleChangeBase}
              show={show}
              showCompare={props.isMainText ? true : true}
              showCompareType={props.isMainText ? 'editDistance' : 'ngram'}
              surfaceWidth={props.surfaceWidth}
              isRelatedToRange={props.isRelatedToRange}
              targetRange={props.targetRange}
              isMainText={props.isMainText}
              relationLabel={props.relationLabel}
              showImages={showImages}
              handleChangeInfo={props.handleChangeInfo}
              />
            )
          }
          else
          {
            return null
          }
          })
          return texts
        }
      }

      const displayTranslations = () => {
        if (showTranslations){
          if (info.manifestations){
          console.log("info.manifestations", info.manifestations)
          const texts = info.manifestations.map((m: any) => {
            if (m.manifestationLanguage !== "la"){
            return (
              <TextCompareItem
              key={m.transcription}
              base={props.baseText}
              compareTranscription={m.transcription}
              compareTranscriptionDoc={m.transcriptionDoc}
              manifestationTitle={m.manifestationTitle}
              manifestation={m.manifestation}
              handleChangeBase={props.handleChangeBase}
              show={show}
              showCompare={props.isMainText ? true : true}
              showCompareType={'ngram'}
              surfaceWidth={props.surfaceWidth}
              isRelatedToRange={props.isRelatedToRange}
              targetRange={props.targetRange}
              isMainText={props.isMainText}
              relationLabel={props.relationLabel}
              showImages={showImages}
              />
            )
          }
          else
          {
            return null
          }
        })
  
            return (
              <div id="translationwrapper" style={{paddingLeft: "50px"}}>
                {texts}
                <p onClick={() => {setShowTranslations(!showTranslations)}}>Hide Translation(s)</p>
              </div>
            )
    
        }
        else{
          if (Array.isArray(info.manifestations) && info?.manifestations.some((f: any) => (f.manifestationLanguage && f.manifestationLanguage) !== "la")){
            return (<p onClick={() => {setShowTranslations(!showTranslations)}}>View Translation(s)</p>)
          }
          else{
          return null
          }
        }
      }
      }
  return(

    <div style={{"borderBottom": "1px solid rgba(0, 0, 0, 0.1)", padding: "5px"}}>
      {
        // the link to reroute is not quite working, because the base Text is not resetting, focusBlockChange might be better; but item structure will also need to be changed.
      }

      <div style={{fontSize: "12px"}}>
        {props.isMainText && <span>[Target] </span>}
        <span>{props.relationLabel}</span> 
        {(props.referringResource && props.referringResource !== info.resourceid) 
        && <span className="lbp-span-link" onClick={() => {props.handleChangeInfo(props.referringResource)}}> (via) </span>}
      </div>
      <div>
        {info.resourceid ?
        <span className="lbp-span-link" onClick={() => { props.handleChangeInfo(info.resourceid + ((props.relationLabel !== "isQuotedBy" && props.relationLabel !== "isReferencedBy" && props.isRelatedToRange) ? "@" + props.isRelatedToRange : ""))}}>
          {props.authorTitle || props.longTitle ? <span> {props.authorTitle} {props.longTitle}</span> : info.resourceid}
        </span> :
        props.authorTitle || props.longTitle ? <span> {props.authorTitle} {props.longTitle}</span> : info.resourceid
        }
        <span> | </span>
        {info.resourceid && <span className="lbp-span-link" onClick={() => setShow(!show)}>{show ? <FaEyeSlash/> : <FaEye/>}</span>}
        <span> | </span>
        {props.expressionid && <span className="lbp-span-link" title="add to collation table" onClick={() => {props.handleUpdateCompareExpressionIds?.(props.expressionid)}}><FaTable/></span>}
        <span> | </span>
        <a href={"https://mirador.scta.info?blockid=" + info.resourceid} target="_blank" rel="noopener noreferrer"><img alt="view in mirador" style={{width: "12px", height: "12px"}} src="https://projectmirador.org/img/mirador-logo.svg"></img></a>

        <span> | </span>
      </div>
      <div className={show ? "unhidden" : "hidden"} style={{"paddingLeft": "10px"}}>
        <div style={{display: "flex", justifyContent: "space-between"}}>
        <div>
        {displayComparisons()}
        </div>
        {displayTranslations()}
        </div>
      </div>
    </div>
    );
  };

